import {useAppSelector} from "../app/hooks";
import {getRole} from "../features/auth/authSlice";
import {UserRoleEnum} from "../features/users/redux/userTypes";
import {Navigate, Outlet} from "react-router-dom";

export const AdminRoute = () => {
    const role = useAppSelector(getRole)

    return role === UserRoleEnum.ADMIN ? <Outlet /> : <Navigate to={'/panel/bons/charge'} />
}